import { createSlice } from "@reduxjs/toolkit";
import { setAxiosToken } from "../../helpers/request";
import { login, loginVerify, resetPassword, userRegister } from "./userRequests";

const initialState = {
  currentUser: null,
  currentToken: '',
}

const TOKEN_NAME = 'id';

const saveToken = (token) => localStorage.setItem(TOKEN_NAME, token);

const removeToken = () => localStorage.removeItem(TOKEN_NAME);

const userSlice = createSlice({
  name: 'userSlice',
  initialState,
  reducers: {
    loadToken: (state, action) => {
      const token = localStorage.getItem(TOKEN_NAME);

      if (token) {
        state.currentToken = token;
        setAxiosToken(token);
      }
    },
    logout: (state, action) => {
      localStorage.removeItem(TOKEN_NAME);
    }
  },
  extraReducers: (builder) =>
    builder
      .addCase(login.fulfilled, (state, action) => {
        const { user, jwt } = action.payload;

        if (!user || !jwt) {
          return;
        }

        state.currentUser = user;
        state.currentToken = jwt;
        setAxiosToken(jwt);
        saveToken(jwt);
      })
      .addCase(loginVerify.fulfilled, (state, action) => {
        const user = action.payload;
        if (user) {
          state.currentUser = user;
        } else {
          state.currentUser = null;
          removeToken();
        }
      })
      .addCase(userRegister.fulfilled, (state, action) => {
        const { user, jwt } = action.payload || {};

        if (!user || !jwt) {
          return;
        }

        state.currentUser = user;
        state.currentToken = jwt;
        setAxiosToken(jwt);
        saveToken(jwt);
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        const { user, jwt } = action.payload || {};

        if (!user || !jwt) {
          return;
        }

        state.currentUser = user;
        state.currentToken = jwt;
        setAxiosToken(jwt);
        saveToken(jwt);
      })
})

export const { loadToken, logout } = userSlice.actions;

export default userSlice;